type ErrorWithStatus = {
  status?: number;
  message?: string;
};

function isRecord(value: unknown): value is Record<string, unknown> {
  return typeof value === 'object' && value !== null;
}

export function getHttpStatus(error: unknown): number | undefined {
  if (!isRecord(error)) return undefined;

  if (typeof error.status === 'number') {
    return error.status;
  }

  return undefined;
}

export function getApiErrorMessage(error: unknown, fallback: string): string {
  if (error instanceof Error && error.message.length > 0) {
    return error.message;
  }

  if (isRecord(error) && typeof error.message === 'string' && error.message.length > 0) {
    return error.message;
  }

  return fallback;
}

export type { ErrorWithStatus };
